import './cifre.scss';

/**
 * version    1.0
 * class      <type> (Cifre)
 * classdesc  Component that manage the page header
 */
export class Cifre {}
